// extracted by mini-css-extract-plugin
module.exports = {"BundlesCommon":"TabBundles_BundlesCommon__R46Ya","BundlesCommon2":"TabBundles_BundlesCommon2__gByZv","BundlesCommonJp":"TabBundles_BundlesCommonJp__1wB7s"};